import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { scheduleAListService } from "services";
import { uiActions } from "store";
import { ChangeScheduleAStatusProps, ErrorResponse } from "types";

const useUpdateScheduleAStatusMutation = onSuccess => {
	const dispatch = useDispatch();

	return useMutation(
		({ userId, scheduleId, status }: ChangeScheduleAStatusProps) => {
			dispatch(uiActions.showSpinnerOverlay());
			return scheduleAListService.changeStatus({
				userId,
				scheduleId,
				status,
			});
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateScheduleAStatusMutation;
